// extracted by mini-css-extract-plugin
export default {"toasts":"Toasts_toasts__DZYe2","toastrWrapper":"Toasts_toastrWrapper__IyP08"};